import { RouteObject } from "react-router-dom";
import SigninView from ".";
import SigninPrivateKeyView from "./nsec";
import SigninStartView from "./start";

export default [
  {
    element: <SigninView />,
    children: [
      { path: "", element: <SigninStartView /> },
      { path: "nsec", element: <SigninPrivateKeyView /> },
    ],
  },
] satisfies RouteObject[];
